<app-dialog-banner text="Resolve Request {{ sr?.refNr }}" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content class="mat-typography" style="max-width: 800px;"
        [attr.data-form-ready]="ready ? 'true' : null">
    <app-field-set [fieldSet]="fieldSet" [isPhone]="isPhone" [initComplete]="ready"></app-field-set>
    <p style="margin-top: -20px; font-size:small; text-align: center; line-height: 1em; max-width: 100%; padding-left: 10px">
        {{comment}}
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (!fieldSet.formGroup?.valid) {
        <button mat-raised-button i18n (click)="highlightErrors()">Show Errors</button>
    }    
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button (click)="closeRequest()" [disabled]="!fieldSet.formGroup?.valid" color="primary"
        data-save-button cdkFocusInitial>Close Request</button>
</mat-dialog-actions>
